/**
 * Hook personalizado para manejar datos de momios
 * Centraliza la lógica de extracción de momios para diferentes casas de apuestas
 * 
 * @param {Object} item - Datos del evento deportivo
 * @param {boolean} isStrendus - Determina qué casa de apuestas usar
 * @returns {Object} Funciones para obtener datos de momios
 */
export function useMomiosData(item = {}, isStrendus = false) {
  
  /**
   * Obtiene los datos de momios según la casa de apuestas seleccionada
   */
  const getMomiosSource = () => {
    return isStrendus ? item.strendus_data || {} : item.caliente_metadata || {};
  };

  /**
   * Extrae valor y URL normalizada para una posición específica
   * @param {string} position - Posición del momio ('left', 'middle', 'right')
   * @returns {Object} Objeto con value y url normalizados
   */
  const getMomioData = (position) => {
    const source = getMomiosSource();
    return {
      value: source[`${position}_mm`],
      url: String(source[`${position}_url_mm`] || '').trim()
    };
  };

  /**
   * Obtiene todos los momios de una vez
   * @returns {Object} Objeto con left, middle y right momios
   */
  const getAllMomios = () => {
    return {
      left: getMomioData('left'),
      middle: getMomioData('middle'),
      right: getMomioData('right')
    };
  };

  return {
    getMomiosSource,
    getMomioData,
    getAllMomios
  };
}